/**
 * merlin_api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface UserVM { 
    id?: number;
    firstName: string;
    lastName: string;
    email: string;
    phone?: string | null;
    addressId?: number | null;
    createdAt?: string;
    updatedAt?: string;
    deletedAt?: string | null;
    existInMerlin?: boolean;
}

